const LANGUAGE_STORAGE_KEY = 'preferred-language'

/**
 * Save language to localStorage
 */
export const saveLanguageToStorage = (language: string): void => {
  if (typeof window !== 'undefined') {
    try {
      localStorage.setItem(LANGUAGE_STORAGE_KEY, language)
    } catch (error) {
      console.warn('Failed to save language to localStorage:', error)
    }
  }
}

/**
 * Get language from localStorage
 */
export const getLanguageFromStorage = (): string | null => {
  if (typeof window !== 'undefined') {
    try {
      return localStorage.getItem(LANGUAGE_STORAGE_KEY)
    } catch (error) {
      console.warn('Failed to get language from localStorage:', error)
    }
  }
  return null
}

/**
 * Remove lang parameter from URL
 */
export const removeLangFromUrl = (): void => {
  if (typeof window !== 'undefined') {
    const url = new URL(window.location.href)
    url.searchParams.delete('lang')

    // Update URL without page reload
    window.history.replaceState({}, '', url.toString())
  }
}

/**
 * Detect language by priority: URL → localStorage → default
 * If URL parameter is found, save it to localStorage
 */
export const detectLanguage = (defaultLang: string = 'PL'): string => {
  // 1. Check URL parameter
  if (typeof window !== 'undefined') {
    const urlParams = new URLSearchParams(window.location.search)
    const langParam = urlParams.get('lang')

    if (langParam && ['en', 'pl'].includes(langParam.toLowerCase())) {
      const detectedLang = langParam.toUpperCase()
      // Save URL language to localStorage for future visits
      saveLanguageToStorage(detectedLang)
      return detectedLang
    }
  }

  // 2. Check localStorage
  const storedLang = getLanguageFromStorage()
  if (storedLang && ['EN', 'PL'].includes(storedLang)) {
    return storedLang
  }

  // 3. Return default
  return defaultLang
}
